module.exports = __webpack_public_path__ + "media/images/imgAI-cc0ffefb6094ae20d90aecb3d1e664ea.png";